import { IInfrastructureType } from '../../types/newbuilding/infrastructureTypes';
import { IApplicationState } from '../../types/redux';

export function getInfrastructureMapTypes(state: IApplicationState): IInfrastructureType[] | null {
  const { infrastructureTypes } = state.newbuilding;

  if (!infrastructureTypes.length) {
    return null;
  }

  return infrastructureTypes;
}
